function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__b",
  d: "M.974 4.471L7.122 18.04l9.409-1.464s.265 10.944 4.493 13.544c2.656 1.633 4.589 1.325 6.648 1.016 1.22-.183 2.486-.366 3.973-.146.344-1.932-2.895-3.425-2.895-3.425s1.826-.643 4.35-.287c.26-2.168-2.813-3.286-2.813-3.286s1.286-.6 3.218-.545c-.069-3.216-6.741-2.119-6.741-2.119S32.193 3.02 21.711.571c-1.37-.32-2.797-.456-4.232-.456C9.36.114.974 4.471.974 4.471"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__e",
  d: "M4.776 7.706l6.312 9.422S1.345 22.116.837 27.054C.331 31.993 3.686 33.674 4.665 37c2.726-.879 1.407-3.991 1.407-3.991s1.798 1.035 3.391 3.807c1.971-1.361.914-4.077.914-4.077s2.274.688 3.8 2.608c1.85-3.143-2.927-6.939-2.927-6.939s18.849-3.056 16.505-13.562C25.715 5.7 16.968.478 16.968.478L4.776 7.706z"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__h",
  d: "M1.399 4.94c2.637 10.993-1.922 14.196-.185 22.323 1.632 7.632 6.405 9.421 8.727 11.163 5.586 4.187 14.39-4.524 16.901-11.688 2.353-6.705-2.709-15.158-4.993-20.191C19.854 2.148 14.857.511 10.297.511 5.29.51.809 2.483 1.399 4.94"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__k",
  d: "M.973 13.715c1.472 2.187 1.936 4.668 4.827 6.341 1.73 1.001 5.309.827 6.07-2.245.821-3.31-1.376-5.591-2.073-9.492C9.164 4.781 6.775 2.061 4.749.584 6.011 9.314-2.832 8.059.973 13.715"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__n",
  d: "M.997 11.166C-.74 14.65 6.021 12.28 3.405 19.74-.423 30.654 24.181 32.836 29.597 29.944c.69-.369 3.788-5.306 2.758-7.794.241-1.277.035-.947.135-2.224 1.795-1.288-.073-3.724-.747-4.425.967-2.567.577-4.255-.199-5.644-1.004-1.794-6.418-5.968-8.559-7.453-1.516-1.052-3.682-1.645-6.11-1.645C11.446.759 4.709 3.725.997 11.166"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__q",
  d: "M.997 11.166C-.74 14.65 6.021 12.28 3.405 19.74-.423 30.654 24.181 32.836 29.597 29.944c1.254-.67 4.843-11.64 2.146-14.443.967-2.567.577-4.255-.199-5.644-1.004-1.794-6.418-5.968-8.559-7.453-1.516-1.052-3.682-1.645-6.11-1.645C11.446.759 4.709 3.725.997 11.166"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__s",
  d: "M.997 11.166C-.74 14.65 6.021 12.28 3.405 19.74-.423 30.654 24.181 32.836 29.597 29.944c1.254-.67 4.843-11.64 2.146-14.443.967-2.567.577-4.255-.199-5.644-1.004-1.794-6.418-5.968-8.559-7.453-1.516-1.052-3.682-1.645-6.11-1.645C11.446.759 4.709 3.725.997 11.166"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__u",
  d: "M.997 11.166C-.74 14.65 6.021 12.28 3.405 19.74-.423 30.654 24.181 32.836 29.597 29.944c1.254-.67 4.843-11.64 2.146-14.443.967-2.567.577-4.255-.199-5.644-1.004-1.794-6.418-5.968-8.559-7.453-1.516-1.052-3.682-1.645-6.11-1.645C11.446.759 4.709 3.725.997 11.166"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__w",
  d: "M.997 11.166C-.74 14.65 6.021 12.28 3.405 19.74-.423 30.654 24.181 32.836 29.597 29.944c1.254-.67 4.843-11.64 2.146-14.443.967-2.567.577-4.255-.199-5.644-1.004-1.794-6.418-5.968-8.559-7.453-1.516-1.052-3.682-1.645-6.11-1.645C11.446.759 4.709 3.725.997 11.166"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__y",
  d: "M.997 11.166C-.74 14.65 6.021 12.28 3.405 19.74-.423 30.654 24.181 32.836 29.597 29.944c1.254-.67 4.843-11.64 2.146-14.443.967-2.567.577-4.255-.199-5.644-1.004-1.794-6.418-5.968-8.559-7.453-1.516-1.052-3.682-1.645-6.11-1.645C11.446.759 4.709 3.725.997 11.166"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__A",
  d: "M.997 11.166C-.74 14.65 6.021 12.28 3.405 19.74-.423 30.654 24.181 32.836 29.597 29.944c1.254-.67 4.843-11.64 2.146-14.443.967-2.567.577-4.255-.199-5.644-1.004-1.794-6.418-5.968-8.559-7.453-1.516-1.052-3.682-1.645-6.11-1.645C11.446.759 4.709 3.725.997 11.166"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__C",
  d: "M.997 11.166C-.74 14.65 6.021 12.28 3.405 19.74-.423 30.654 24.181 32.836 29.597 29.944c1.254-.67 4.843-11.64 2.146-14.443.967-2.567.577-4.255-.199-5.644-1.004-1.794-6.418-5.968-8.559-7.453-1.516-1.052-3.682-1.645-6.11-1.645C11.446.759 4.709 3.725.997 11.166z"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__E",
  d: "M.997 11.166C-.74 14.65 6.021 12.28 3.405 19.74-.423 30.654 24.181 32.836 29.597 29.944c1.254-.67 4.843-11.64 2.146-14.443.967-2.567.577-4.255-.199-5.644-1.004-1.794-6.418-5.968-8.559-7.453-1.516-1.052-3.682-1.645-6.11-1.645C11.446.759 4.709 3.725.997 11.166"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__G",
  d: "M.997 11.166C-.74 14.65 6.021 12.28 3.405 19.74-.423 30.654 24.181 32.836 29.597 29.944c1.254-.67 4.843-11.64 2.146-14.443.967-2.567.577-4.255-.199-5.644-1.004-1.794-6.418-5.968-8.559-7.453-1.516-1.052-3.682-1.645-6.11-1.645C11.446.759 4.709 3.725.997 11.166"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__I",
  d: "M.997 11.166C-.74 14.65 6.021 12.28 3.405 19.74-.423 30.654 24.181 32.836 29.597 29.944c1.254-.67 4.843-11.64 2.146-14.443.967-2.567.577-4.255-.199-5.644-1.004-1.794-6.418-5.968-8.559-7.453-1.516-1.052-3.682-1.645-6.11-1.645C11.446.759 4.709 3.725.997 11.166"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__K",
  d: "M.997 11.166C-.74 14.65 6.021 12.28 3.405 19.74-.423 30.654 24.181 32.836 29.597 29.944c1.254-.67 4.843-11.64 2.146-14.443.967-2.567.577-4.255-.199-5.644-1.004-1.794-6.418-5.968-8.559-7.453-1.516-1.052-3.682-1.645-6.11-1.645C11.446.759 4.709 3.725.997 11.166"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__M",
  d: "M.997 11.166C-.74 14.65 6.021 12.28 3.405 19.74-.423 30.654 24.181 32.836 29.597 29.944c1.254-.67 4.843-11.64 2.146-14.443.967-2.567.577-4.255-.199-5.644-1.004-1.794-6.418-5.968-8.559-7.453-1.516-1.052-3.682-1.645-6.11-1.645C11.446.759 4.709 3.725.997 11.166"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__O",
  d: "M.997 11.166C-.74 14.65 6.021 12.28 3.405 19.74-.423 30.654 24.181 32.836 29.597 29.944c1.254-.67 4.843-11.64 2.146-14.443.967-2.567.577-4.255-.199-5.644-1.004-1.794-6.418-5.968-8.559-7.453-1.516-1.052-3.682-1.645-6.11-1.645C11.446.759 4.709 3.725.997 11.166"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__Q",
  d: "M.694.606a.8.8 0 00-.485.253.793.793 0 00-.209.515v.047c.004.135.043.27.117.392.167.272.841 1.516 1.031 1.863.82 1.511 3.524 4.549 4.495 8.466.098.377.224.813.375 1.249l2.342.042-1.637 1.613a9.698 9.698 0 003.235 3.824l2.498-1.702-.679 2.548c1.259.37 2.905.377 4.669-.086l.009-.004c3.905-3.385 3.204-12.43 1.163-14.849a5.068 5.068 0 00-1.883-1.218l-.009-.004c-.808-.284-1.794-.287-3.042-.29C10.157 3.259 6.34 3.249 1.15.682A.802.802 0 00.797.599a.876.876 0 00-.103.007"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__T",
  d: "M1.148 2.676c.819 1.511 3.524 4.549 4.495 8.466.098.377.224.813.375 1.249l2.342.042-1.637 1.613a9.698 9.698 0 003.235 3.824l2.498-1.702-.679 2.548c1.17.343 2.395.48 4.678-.09.034-.309.075-.61.119-.892.397-2.581.957-6.117-.209-8.078-.644-1.082-1.398-2.668-5.169-3.527l-.064-.015c-.683-.147-2.506-.38-4.508-1.219C2.597 3.208.117.813.117.813c.167.272.841 1.516 1.031 1.863"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__W",
  d: "M.448.289c-.376.304-.068.788.789.954A2.126 2.126 0 003.044.806c.213-.234-.07-.571-.483-.626 0 0-.55-.061-1.098-.061-.427 0-.853.037-1.015.17"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__Z",
  d: "M.874.852c-.108.417.805.737 1.386.589.582-.148 1.085-1.268.106-1.296L2.324.144C1.811.144.98.446.874.852"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__ac",
  d: "M3.262.176C2.553.273.949.998.96 1.377c.009.379 1.141 1.01 2.357.779 1.216-.231 1.71-.438 1.622-.888C4.875.928 4.077.166 3.395.166a.833.833 0 00-.133.01"
}), /*#__PURE__*/React.createElement("path", {
  id: "mascot-hanging_svg__af",
  d: "M18.264 7.83c.629 4.583 3.265 18.237.241 20.917C14.285 32.489-2.157 37.97.949 46.56c3.367 9.31 23.57-5.473 27.108-12.649 2.706-5.491-.146-20.424.239-23.352.201-1.522 1.761-3.626 4.521-2.722-.239-2.836-1.791-3.478-3.126-3.489-.602-2.65-2.211-2.945-3.568-2.651-.498-1-1.25-1.421-2.096-1.422-2.654 0-6.229 4.148-5.763 7.555"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mascot-hanging_svg__a",
  x1: "49.735%",
  x2: "51.493%",
  y1: "48.726%",
  y2: "-15.127%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#878EC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mascot-hanging_svg__c",
  x1: "27.751%",
  x2: "126.947%",
  y1: "24.421%",
  y2: "90.78%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#878EC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mascot-hanging_svg__f",
  x1: "11.906%",
  x2: "125.517%",
  y1: "37.357%",
  y2: "83.915%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#878EC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mascot-hanging_svg__i",
  x1: "23.896%",
  x2: "121.56%",
  y1: "39.482%",
  y2: "83.074%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#878EC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mascot-hanging_svg__l",
  x1: "50.95%",
  x2: "125.068%",
  y1: "58.535%",
  y2: "-123.182%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#878EC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mascot-hanging_svg__o",
  x1: "73.577%",
  x2: "-19.259%",
  y1: "80.291%",
  y2: "-33.691%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#878EC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mascot-hanging_svg__R",
  x1: "135.005%",
  x2: "3.266%",
  y1: "168.799%",
  y2: "-52.099%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#878EC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mascot-hanging_svg__U",
  x1: "96.746%",
  x2: "7.449%",
  y1: "94.179%",
  y2: "2.507%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mascot-hanging_svg__X",
  x1: "48907.318%",
  x2: "49322.893%",
  y1: "-5137.438%",
  y2: "-5181.554%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mascot-hanging_svg__aa",
  x1: "67382.65%",
  x2: "67954.482%",
  y1: "-11118.219%",
  y2: "-11213.081%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mascot-hanging_svg__ad",
  x1: "34787.559%",
  x2: "35082.045%",
  y1: "-4487.297%",
  y2: "-4525.77%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "mascot-hanging_svg__ag",
  x1: "20.948%",
  x2: "103.011%",
  y1: "37.863%",
  y2: "76.081%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#878EC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#mascot-hanging_svg__a)",
  d: "M19.018 9.289c.42 4.607 5.486 16.782 5.397 22.242-.104 6.429-10.4 20.07-1.999 23.048 10.723 3.802 13.1-13.412 12.783-20.777-.263-6.116-6.803-18.423-6.284-21.332.27-1.51 1.923-3.542 4.64-2.514-.11-2.844-1.633-3.556-2.965-3.627-.48-2.675-2.074-3.042-3.443-2.81C26.673 2.449 25.893 2 25 2c-2.644.001-6.288 3.915-5.98 7.289",
  transform: "rotate(-18 17.642 27.06)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(33 49.693)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__b"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#mascot-hanging_svg__c)",
  d: "M.974 4.471L7.122 18.04l9.409-1.464s.265 10.944 4.493 13.544c2.656 1.633 4.589 1.325 6.648 1.016 1.22-.183 2.486-.366 3.973-.146.344-1.932-2.895-3.425-2.895-3.425s1.826-.643 4.35-.287c.26-2.168-2.813-3.286-2.813-3.286s1.286-.6 3.218-.545c-.069-3.216-6.741-2.119-6.741-2.119S32.193 3.02 21.711.571c-1.37-.32-2.797-.456-4.232-.456C9.36.114.974 4.471.974 4.471",
  mask: "url(#mascot-hanging_svg__d)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(16 51.693)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__g",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__e"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#mascot-hanging_svg__f)",
  d: "M4.776 7.706l6.312 9.422S1.345 22.116.837 27.054C.331 31.993 3.686 33.674 4.665 37c2.726-.879 1.407-3.991 1.407-3.991s1.798 1.035 3.391 3.807c1.971-1.361.914-4.077.914-4.077s2.274.688 3.8 2.608c1.85-3.143-2.927-6.939-2.927-6.939s18.849-3.056 16.505-13.562C25.715 5.7 16.968.478 16.968.478L4.776 7.706z",
  mask: "url(#mascot-hanging_svg__g)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(18 31.693)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__j",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__h"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#mascot-hanging_svg__i)",
  d: "M1.399 4.94c2.637 10.993-1.922 14.196-.185 22.323 1.632 7.632 6.405 9.421 8.727 11.163 5.586 4.187 14.39-4.524 16.901-11.688 2.353-6.705-2.709-15.158-4.993-20.191C19.854 2.148 14.857.511 10.297.511 5.29.51.809 2.483 1.399 4.94",
  mask: "url(#mascot-hanging_svg__j)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(34 6.693)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__m",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__k"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#mascot-hanging_svg__l)",
  d: "M.973 13.715c1.472 2.187 1.936 4.668 4.827 6.341 1.73 1.001 5.309.827 6.07-2.245.821-3.31-1.376-5.591-2.073-9.492C9.164 4.781 6.775 2.061 4.749.584 6.011 9.314-2.832 8.059.973 13.715",
  mask: "url(#mascot-hanging_svg__m)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13 10.693)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__p",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__n"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#mascot-hanging_svg__o)",
  d: "M.997 11.166C-.74 14.65 6.021 12.28 3.405 19.74-.423 30.654 24.181 32.836 29.597 29.944c.69-.369 3.788-5.306 2.758-7.794.241-1.277.035-.947.135-2.224 1.795-1.288-.073-3.724-.747-4.425.967-2.567.577-4.255-.199-5.644-1.004-1.794-6.418-5.968-8.559-7.453-1.516-1.052-3.682-1.645-6.11-1.645C11.446.759 4.709 3.725.997 11.166",
  mask: "url(#mascot-hanging_svg__p)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13 10.693)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__r",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__q"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M34.828 20.344c.557-.53 1.394-1.448 1.104-2.154-.01-.026-.046-.037-.08-.027a.07.07 0 00-.037.03c-.342.668-1.129 1.114-1.936 1.388-.032.011-.05.04-.039.065a.038.038 0 00.013.018l.882.687a.077.077 0 00.09-.005l.003-.002",
  mask: "url(#mascot-hanging_svg__r)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__t",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__s"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M33.425 21.442c.332-.213.647-.443.943-.688.037-.031.039-.078.004-.105l-.953-.747c-.024-.02-.063-.017-.09.004a.056.056 0 00-.018.036l-.034 1.445c-.002.084.065.108.148.055",
  mask: "url(#mascot-hanging_svg__t)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__v",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__u"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M32.774 21.581l.036-1.534c.002-.082-.08-.145-.183-.139-.012 0-.024.002-.036.004-.115.02-.231.044-.34.063-.304.053-.65.114-1.03.151l-.081.01c-.103.013-.18.09-.173.171a.128.128 0 00.054.091l1.647 1.225a.075.075 0 00.088-.006.05.05 0 00.018-.036",
  mask: "url(#mascot-hanging_svg__v)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__x",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__w"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M29.747 23.116a19.443 19.443 0 002.384-.958c.123-.059.17-.183.105-.276a.18.18 0 00-.043-.044 509.358 509.358 0 01-1.935-1.446c-.024-.019-.063-.017-.088.004a.055.055 0 00-.019.03l-.729 2.478c-.03.11.052.211.185.227a.303.303 0 00.14-.015",
  mask: "url(#mascot-hanging_svg__x)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__z",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__y"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M28.854 23.205l.762-2.655c.03-.109-.052-.21-.186-.227a.274.274 0 00-.064 0l-1.006.08c-.592.046-1.168.09-1.806.16-.103.011-.182.086-.176.17a.122.122 0 00.035.075l2.328 2.423c.018.022.056.027.086.01.014-.009.025-.022.027-.036",
  mask: "url(#mascot-hanging_svg__z)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__B",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__A"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M25.66 24.184a44.339 44.339 0 002.34-.549c.133-.036.214-.149.18-.254a.162.162 0 00-.039-.065l-2-2.112c-.02-.02-.058-.024-.086-.006a.052.052 0 00-.026.033l-.657 2.737c-.026.11.061.208.196.221a.312.312 0 00.091-.005",
  mask: "url(#mascot-hanging_svg__B)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__D",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__C"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M24.723 24.116c.016.023.054.03.084.017a.059.059 0 00.033-.038l.758-3.16c.025-.11-.063-.208-.198-.22a.347.347 0 00-.072.002 39.405 39.405 0 00-2.217.39c-.136.029-.227.138-.202.245a.164.164 0 00.023.053l1.79 2.71z",
  mask: "url(#mascot-hanging_svg__D)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__F",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__E"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M21.614 24.76c.746-.069 1.541-.16 2.387-.284.137-.02.237-.123.223-.232a.156.156 0 00-.025-.069l-1.55-2.349c-.016-.024-.054-.03-.085-.017a.067.067 0 00-.03.031l-1.162 2.669c-.047.105.021.216.151.244.03.006.06.009.091.006",
  mask: "url(#mascot-hanging_svg__F)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__H",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__G"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M20.776 24.631l1.361-3.073c.035-.08-.014-.162-.111-.183a.216.216 0 00-.104.002c-.622.152-1.178.306-1.753.465-.34.095-.684.19-1.052.289-.1.024-.163.11-.139.188.005.012.01.024.02.037l1.66 2.288c.012.026.048.037.08.024a.06.06 0 00.038-.037",
  mask: "url(#mascot-hanging_svg__H)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__J",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__I"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M17.224 24.78c.847.085 1.707.114 2.57.086.139-.004.255-.096.26-.206a.163.163 0 00-.03-.106l-1.532-2.079c-.017-.023-.055-.029-.085-.013a.064.064 0 00-.025.021c-.21.325-.986 1.505-1.325 2.019-.064.101-.02.219.103.263.02.007.042.013.064.015",
  mask: "url(#mascot-hanging_svg__J)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__L",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__K"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M15.868 23.027l.557 1.429c.008.026.043.039.076.029a.066.066 0 00.037-.026l1.135-1.714c.05-.075.017-.163-.074-.197a.219.219 0 00-.127-.008l-.08.019c-.372.094-.717.155-1.02.209-.112.019-.226.039-.343.057-.102.014-.178.09-.169.17a.109.109 0 00.008.032",
  mask: "url(#mascot-hanging_svg__L)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__N",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__M"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M14.644 24.222c.362.13.737.238 1.122.326.096.022.15-.026.12-.1l-.525-1.35c-.01-.026-.045-.039-.078-.028a.065.065 0 00-.037.027l-.642 1.027c-.023.037-.006.081.04.098",
  mask: "url(#mascot-hanging_svg__N)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__P",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__O"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M13.636 23.798c.132.069.272.136.417.2a.075.075 0 00.089-.025l.596-.95c.015-.026.003-.055-.027-.066a.075.075 0 00-.026-.004c-.562.013-1.035-.04-1.426-.16a2.168 2.168 0 01-.868-.48c-.022-.02-.062-.02-.088-.001a.052.052 0 00-.023.039.741.741 0 00.038.252c.133.402.589.815 1.318 1.195",
  mask: "url(#mascot-hanging_svg__P)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 13.693)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__S",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__Q"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#mascot-hanging_svg__R)",
  d: "M.694.606a.8.8 0 00-.485.253.793.793 0 00-.209.515v.047c.004.135.043.27.117.392.167.272.841 1.516 1.031 1.863.82 1.511 3.524 4.549 4.495 8.466.098.377.224.813.375 1.249l2.342.042-1.637 1.613a9.698 9.698 0 003.235 3.824l2.498-1.702-.679 2.548c1.259.37 2.905.377 4.669-.086l.009-.004c3.905-3.385 3.204-12.43 1.163-14.849a5.068 5.068 0 00-1.883-1.218l-.009-.004c-.808-.284-1.794-.287-3.042-.29C10.157 3.259 6.34 3.249 1.15.682A.802.802 0 00.797.599a.876.876 0 00-.103.007",
  mask: "url(#mascot-hanging_svg__S)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 14.693)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__V",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__T"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#mascot-hanging_svg__U)",
  d: "M1.148 2.676c.819 1.511 3.524 4.549 4.495 8.466.098.377.224.813.375 1.249l2.342.042-1.637 1.613a9.698 9.698 0 003.235 3.824l2.498-1.702-.679 2.548c1.17.343 2.395.48 4.678-.09.034-.309.075-.61.119-.892.397-2.581.957-6.117-.209-8.078-.644-1.082-1.398-2.668-5.169-3.527l-.064-.015c-.683-.147-2.506-.38-4.508-1.219C2.597 3.208.117.813.117.813c.167.272.841 1.516 1.031 1.863",
  mask: "url(#mascot-hanging_svg__V)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(32 13.693)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__Y",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__W"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#mascot-hanging_svg__X)",
  d: "M.448.289c-.376.304-.068.788.789.954A2.126 2.126 0 003.044.806c.213-.234-.07-.571-.483-.626 0 0-.55-.061-1.098-.061-.427 0-.853.037-1.015.17",
  mask: "url(#mascot-hanging_svg__Y)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(30 15.693)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__ab",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__Z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#mascot-hanging_svg__aa)",
  d: "M.874.852c-.108.417.805.737 1.386.589.582-.148 1.085-1.268.106-1.296L2.324.144C1.811.144.98.446.874.852",
  mask: "url(#mascot-hanging_svg__ab)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(26 13.693)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__ae",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__ac"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#mascot-hanging_svg__ad)",
  d: "M3.262.176C2.553.273.949.998.96 1.377c.009.379 1.141 1.01 2.357.779 1.216-.231 1.71-.438 1.622-.888C4.875.928 4.077.166 3.395.166a.833.833 0 00-.133.01",
  mask: "url(#mascot-hanging_svg__ae)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#313866",
  d: "M34.87 26.806a5.548 5.548 0 001.484-.581s-1.04-.244-2.48-.62c-3.95-1.036-6.67-2.971-8.645-2.675-1.189.178-1.329 1.888-1.329 1.888a5.826 5.826 0 011.936-.537l.001.009c1.136-.089 2.5.328 4.107.909"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3EB883",
  d: "M29.944 25.2c-2.528-.27-3.667.027-3.667.027.014.48.096.955.244 1.411.508 1.661 1.971 3.145 4.602 2.833a4.438 4.438 0 003.747-2.665"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7DC9A9",
  d: "M31.363 26.24c-1.82-.4-2.778-.217-2.778-.217.008.282.057.561.144.83.298.974 1.156 1.846 2.702 1.663a2.606 2.606 0 002.201-1.565s-.449-.31-2.269-.71"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#313866",
  d: "M42.316 24.32c.75-.642 1.383-1.13 1.974-1.214a2.23 2.23 0 011.06.126s-.296-1.237-.925-1.2c-1.038.045-2.184 1.825-4.053 3.11a16.27 16.27 0 01-1.536.914c-.108.057.71.061 1.183.096"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3EB883",
  d: "M40.019 26.152c.525 1.022 1.39 1.58 2.243 1.448 1.377-.124 1.93-1.404 1.979-2.685a5.208 5.208 0 00-.058-1.065s-.614-.065-1.867.469"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7DC9A9",
  d: "M41.756 25.388c.825-.483 1.31-.491 1.31-.491.032.176.044.355.037.533-.02.643-.322 1.293-1.089 1.378-.476.08-.961-.184-1.26-.687 0 0 .176-.25 1.002-.733"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M32.237 26.472s1.261.014 1.413.543c.152.529-1.892-.205-2.386-.286-.494-.081-.114-.368.973-.257m9.519-1.033s-.752.26-.766.72c-.013.46 1.103-.538 1.387-.7.283-.165.014-.324-.621-.02"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(28 1.693)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mascot-hanging_svg__ah",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mascot-hanging_svg__af"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#mascot-hanging_svg__ag)",
  d: "M18.264 7.83c.629 4.583 3.265 18.237.241 20.917C14.285 32.489-2.157 37.97.949 46.56c3.367 9.31 23.57-5.473 27.108-12.649 2.706-5.491-.146-20.424.239-23.352.201-1.522 1.761-3.626 4.521-2.722-.239-2.836-1.791-3.478-3.126-3.489-.602-2.65-2.211-2.945-3.568-2.651-.498-1-1.25-1.421-2.096-1.422-2.654 0-6.229 4.148-5.763 7.555",
  mask: "url(#mascot-hanging_svg__ah)"
})));

function SvgMascotHanging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67,
    height: 89
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/mascot-hanging.3b599211.svg";
export { SvgMascotHanging as ReactComponent };